import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import AuthService from "../../services/AuthService";
import Login from '../../pages/Login';
import { MemberLinkBtnOrangeDark } from '../../styles/Elements';
import { MdSearch } from 'react-icons/md';
export default class PermissionRequestUsers extends Component {

    state = {
        allUsers: [],
        search: ''
    }

    componentDidMount() {

        this.refreshUsers();
    }

    refreshUsers = () => {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        if (!loggedInUser || (whatRole === ('USER'))) { } else {
            AuthService.getReqToJoinBish()
                .then(res => {
                    const allUsers = res.data;
                    this.setState({ allUsers });

                })
        }
    }


      
    onchangeFind = (event) => {
        this.setState({ search: event.target.value })
      }
      
      filterFunction = (people) => {
        return people.email.indexOf(this.state.search) > -1
      }


      //Details 
      showUser(userName) {
            window.open(`/adminboard/users/${userName}`, '_self');
        }


//Activation and De-activation

        ActivateBish(userName) {
            AuthService.ActivateBish(userName)
            .then((res) => {
                this.refreshUsers();
                window.location.reload();
            })
            .catch((err) => {
            });
        }





    render() {
        const loggedInUser = AuthService.getCurrentUser();
        const whatRole = AuthService.getUserRole();
        return (

            <div className="wrapper-admin-inactive-users">
                { !loggedInUser || (whatRole === ('USER')) ?
                    <div>
                        <Login></Login>
                    </div> :
                    <div className="top-level-page-main users-page-main">
                        <div className="container-view-contents users-page-conents">
                        <div className="list-wrap-contents users-page-wraper">
                        <div className="top-actions users-page">
                        <MemberLinkBtnOrangeDark to='/adminboard/'> Back to Admin Board </MemberLinkBtnOrangeDark>
                        <input
                             type="text" 
                             className="search"
                              name="searchfield" 
                              placeholder="Search Email"
                              value={this.state.search}
                              onChange={this.onchangeFind}
                            />
                              <MdSearch size={40} color="#538D22" />
                          
                          </div>
                        <table className="table-of-users">
                        <tbody>
                        <tr>
                                        <th className="head-table">UserName</th>
                                        <th className="head-table">Email</th>
                                        <th className="head-table">Details</th>
                                        <th className="head-table">Control Roles</th>
                                        </tr>
                            {this.state.allUsers.filter(this.filterFunction).reverse().map(user => (
                               
                                        <tr key={user.id}>
                                        <th>{user.username}</th>
                                        <th>{user.email}</th>

                                    
                                       <th><button className="table-of-users details-btn" onClick={() => this.showUser(user.username)}>Details</button></th>
                                        <th>
                                            <button   onClick={() => { if (window.confirm('Are you sure you want to add Bish Authentication for this user')) this.ActivateBish(user.username)}} 
                                            className="activate-bish">Bish</button>

                                        </th>
                                   
                                    </tr>
                            ))}
                             
                            </tbody>
                             </table>
                            </div>
                        </div>
                     
                    </div>
                }</div>

        )

    }
}